import { TransferSearchTimeType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const transferSearchTimeName: { [key in TransferSearchTimeType]: TKeyType } = {
  [TransferSearchTimeType.CREATED_AT]: 'common.transferTime',
  [TransferSearchTimeType.FINISHED_AT]: 'common.finishTime'
}

export default transferSearchTimeName
